export const RESPONSE_CREATED = "Created"
export const RESPONSE_SUCCESS = "Success"
export const THREEDSREQUIRED = "3dsDeviceDataRequired"
export const async_status = {
  __DEFAULT__: 'async__DEFAULT__',
  __LOADING__: 'async__LOADING__',
  __LOADED__: 'async__LOADED__',
  __FAILED__: 'async__FAILED__',
};

export const user_registration_status = {
  ACCOUNT_CREATED: "ACCOUNT_CREATED",
  EMAIL_VERIFIED: "EMAIL_VERIFIED",
  MOBILE_VERIFIED: "MOBILE_VERIFIED",
  SECURITY_QUESTION_SET: "SECURITY_QUESTION_SET",
  KYC_VERIFIED: "KYC_VERIFIED",
  COMPLETED: "COMPLETED",
}